import { render, staticRenderFns } from "./pretty-data-render.vue?vue&type=template&id=509a0740&"
import script from "./pretty-data-render.vue?vue&type=script&lang=js&"
export * from "./pretty-data-render.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports